
import { defineComponent, VNodeChild } from "vue";
import { children } from "../../utils/vue";
import Node from "../utils/Node.vue";

export default defineComponent({
  components: {
    Node,
  },
  props: {
    vertical: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    large: { type: Boolean, default: false },
    full: { type: Boolean, default: false },
    xlarge: { type: Boolean, default: false },
  },
  computed: {
    children(): VNodeChild[] {
      return children(this);
    },
  },
});
